var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import generate_jwt from "./jwt/jwt";
let authData;
export const updateData = (data) => authData = data;
export const getDataFromStorage = () => {
    return {
        tgt_timestamp: authData.tgtTimestamp,
        tgt_ticket: authData.tgtTicket,
        userInfo: authData.userInfo,
        source: authData.source,
        audience: authData.audience,
        country: authData.country
    };
};
export const generateToken = () => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { tgt_ticket, tgt_timestamp, userInfo } = getDataFromStorage();
    const id = (_a = userInfo.id) === null || _a === void 0 ? void 0 : _a.toString();
    if (!tgt_ticket)
        return null;
    if (!id || id.startsWith("_"))
        throw new Error("ID isn't valid.");
    return document ? generate_jwt(Number(tgt_timestamp), tgt_ticket, id) : "";
});
